import React from "react";
import CustomButton from "../CutomButton/CustomButton";

export default function FindYourDreamHomeV1() {
  return (
    <div className="h-[500px] md:h-[600px] xl:h-[700px] flex flex-col items-center justify-center gap-10 md:w-2/4 md:mx-auto">
      <h2 className="font-[optima-lt-pro] text-white font-[500] text-center uppercase text-xl xs:text-xl md:text-3xl 2xl:text-4xl">
        Ready to find your dream home?
      </h2>
      <p className="text-white font-[lato] text-center text-base xs:text-base md:text-lg 2xl:text-xl">
        Unlock exclusive properties and expert insights with one of Dubai's top
        luxury realtors. Your perfect home awaits!!!
      </p>
      <div>
        <CustomButton
          name={"Find Your Dream Home"}
          link={"/contact-us-dubai-real-estate-agency/"}
        />
      </div>
    </div>
  );
}
